import { useEffect, useRef } from "react";
import CloseButton from "../buttons/close.button";

const Modal = ({ isOpen, onClose, children, containerClassName }) => {
  const modalRef = useRef(null);

  const closeModalOnOutsideClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", closeModalOnOutsideClick);

    return () => {
      document.removeEventListener("mousedown", closeModalOnOutsideClick);
    };
  }, []);
  if (!isOpen) return null;

  return (
    <div
      className="z-40 fixed inset-0 bg-black bg-opacity-50 overflow-y-auto h-full w-full"
      id="my-modal"
    >
      <div
        className={containerClassName ?? "backdrop-blur-sm bg-greenGlass border-animate rounded-2xl flex flex-row relative top-20 mx-auto p-8 max-h-[90%] overflow-y-auto max-w-[80%] w-auto shadow-lg"}
        ref={modalRef}
      >
        <div className="top-2 right-2 absolute">
          <CloseButton onClose={onClose} />
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
